import * as React from "react";
const Minus = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 12 6 13 19 13 19 12z" }));
Minus.displayName = "Minus";
var Minus_default = Minus;
export {
  Minus_default as default
};
